import { useNavigate } from "react-router-dom";
import { DefaultService } from "../generated";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useLogout = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { mutate } = useMutation({
    mutationKey: ["logout"],
    mutationFn: DefaultService.fakturUsersViewsLogoutApi,
    onSettled: () => {
      queryClient.removeQueries({ queryKey: ["session"] });
      queryClient.invalidateQueries({ queryKey: ["session"] });
    },
    onSuccess: () => {
      navigate("/");
    },
  });
  return mutate;
};
